import * as React from "react";
import type { SVGProps } from "react";
const SvgGitBranch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      transform="translate(3.334 2.5)scale(.9141)"
    >
      <path d="M2.708 4.792v6.666" vectorEffect="non-scaling-stroke" />
      <circle
        cx={11.875}
        cy={2.708}
        r={2.083}
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx={2.708}
        cy={13.542}
        r={2.083}
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx={2.708}
        cy={2.708}
        r={2.083}
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M2.708 8.125h5.834a3.333 3.333 0 0 0 3.333-3.333v0"
        vectorEffect="non-scaling-stroke"
      />
    </g>
  </svg>
);
export default SvgGitBranch;
